import React, { useEffect, useState, useContext } from 'react';
import { AuthContext } from '../contexts/auth';
import { addCompanyPermission, removeCompanyPermission, getCompanyPermissions } from '../services/api_permissions';
import PermissionsTable from '../components/permessi_table';
import Swal from 'sweetalert2';
import Fetching from './fetching';

const PermissionSection = () => {
  const { token } = useContext(AuthContext);
  const [activePermissions, setActivePermissions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchActivePermissions = async () => {
      setLoading(true);
      try {
        const permissions = await getCompanyPermissions(token);        
        setActivePermissions(permissions.map(p => p.id));
      } catch (error) {
        console.error("Errore durante il recupero dei permessi attivi:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchActivePermissions();
  }, [token]);

  const handlePermissionChange = async (permissionId, isChecked) => {
    try {
      if (isChecked) {
        await addCompanyPermission(token, permissionId);
        setActivePermissions(prev => [...prev, permissionId]);
      } else {
        await removeCompanyPermission(token, permissionId);
        setActivePermissions(prev => prev.filter(id => id !== permissionId));
      }
    } catch (error) {
      console.error("Errore nell'aggiornare il permesso:", error);
      Swal.fire({
        title: 'Errore',
        text: 'Si è verificato un errore durante l\'aggiornamento del permesso. Riprova più tardi.',
        icon: 'error',
        confirmButtonText: 'OK'
      });
    }
  };

  if (loading) {
    return <Fetching />;
  }

  return (
    <div>
      <PermissionsTable
        activePermissions={activePermissions}
        onChange={handlePermissionChange}
      />
    </div>
  );
};

export default PermissionSection;
